if (!customElements.get('product-accordion')) {
  class ProductAccordion extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('.accordion-trigger');
      if (!this.trigger) return;
      this.trigger.addEventListener('click', () => this.toggle());
    }

    toggle() {
      const isExpanded = this.trigger.getAttribute('aria-expanded') === 'true';
      const contentId  = this.trigger.getAttribute('aria-controls');
      const content    = document.getElementById(contentId);
      if (!content) return;

      if (!isExpanded) {
        /* Close every other accordion in the same product info container */
        const container = this.closest('#ProductInfo-' + this.dataset.section);
        if (container) {
          container.querySelectorAll('product-accordion').forEach((acc) => {
            if (acc !== this) acc.close();
          });
        }
      }

      this.trigger.setAttribute('aria-expanded', String(!isExpanded));
      if (isExpanded) {
        content.setAttribute('hidden', '');
      } else {
        content.removeAttribute('hidden');
      }
    }

    close() {
      const trigger   = this.querySelector('.accordion-trigger');
      const contentId = trigger?.getAttribute('aria-controls');
      const content   = contentId ? document.getElementById(contentId) : null;
      if (trigger)  trigger.setAttribute('aria-expanded', 'false');
      if (content)  content.setAttribute('hidden', '');
    }
  }

  customElements.define('product-accordion', ProductAccordion);
}
